export const replacePlaceholders = (
    template: string,
    values: { [key: string]: string | number | null }, // Add null
) => {
    return Object.keys(values).reduce((result, key) => {
        const value = values[key] ?? ''; // Replace null with empty string
        return result.replace(new RegExp(`%${key}%`, 'g'), String(value));
    }, template);
};

export const currencySymbol = () => {
    return '$';
};
